// Ensure React is loaded before anything else
import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

// Safety check: ensure React is available
if (!React || typeof React.useState !== 'function') {
  console.error('React is not loaded correctly. Check vendor-react bundle.');
  throw new Error('React is not available');
}

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root container not found');
}

const root = createRoot(container);
root.render(<App />);
